import React              from 'react';
import { reduxForm }      from 'redux-form';
import { useTranslation } from 'react-i18next';

import RenderButton            from '../../../../components/buttons/base/RenderButton';
import { RenderPasswordField } from '../../../../components/fields/redux/RenderPasswordField';

function ChangeAccountData({ ...props }) {
  const {
          cancel,
          form,
          handleSubmit,
          submitForm,
        }     = props;
  const { t } = useTranslation();

  return (
    <form
      name={form}
      className={form}
      noValidate={true}
      method={'post'}
      onSubmit={event => submitForm(event, handleSubmit)}
    >
      <section>
        <div className={'container'}>
          <div className={'line'}>
            <RenderPasswordField
              name={'oldPassword'}
              label={t('client_oldPassword')}
            />
          </div>
          <div className={'line'}>
            <RenderPasswordField
              name={'password'}
              label={t('client_newPassword')}
            />
          </div>
          <div className={'line'}>
            <RenderPasswordField
              name={'passwordRepeat'}
              label={t('field_passwordRepeat')}
            />
          </div>
        </div>
      </section>
      <section className={'to-catalog'}>
        <div className={'container'}>
          <RenderButton
            type={'submit'}
            className={'fill'}
            label={t('btn_save')}
          />
          <RenderButton
            action={cancel}
            label={t('btn_cancel')}
          />
        </div>
      </section>
    </form>
  );
}

export default reduxForm({
  form:         'ChangeAccountData',
  validate:     () => {
  },
  onSubmitFail: () => {
  },
})(ChangeAccountData);